import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/AuthContext';
import { LangToggle } from './LangToggle';
import { ThemeToggle } from './ThemeToggle';

export function TopNav() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const loc = useLocation();
  const showBack = loc.pathname !== '/' && loc.pathname !== '/home';

  return (
    <header
      className="sticky top-0 z-50 flex items-center justify-between gap-4 px-4 py-3"
      style={{
        background: 'color-mix(in srgb, var(--surface) 92%, transparent)',
        backdropFilter: 'saturate(160%) blur(10px)',
        borderBottom: '1px solid var(--border)',
      }}
    >
      <Link
        to="/"
        className="flex items-center gap-2 text-[20px] font-extrabold tracking-tight text-ink"
        style={{ letterSpacing: '-0.01em' }}
      >
        {showBack && (
          <span
            aria-hidden="true"
            className="grid h-9 w-9 place-items-center rounded-pill"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
          </span>
        )}
        <span className="brand-mark" aria-hidden="true">
          O
        </span>
        <span>{t('brand.name')}</span>
        <style>
          {`
            .brand-mark {
              position: relative;
              display: inline-grid;
              place-items: center;
              width: 32px;
              height: 32px;
              background: var(--soi-600);
              color: #fff;
              border-radius: 8px;
              font-weight: 900;
              font-size: 18px;
              overflow: hidden;
            }
            .brand-mark::after {
              content: '';
              position: absolute;
              top: -6px; right: -6px;
              width: 14px; height: 14px;
              background: var(--surface);
              border-radius: 50%;
            }
          `}
        </style>
      </Link>
      <nav className="flex items-center gap-2">
        <ThemeToggle />
        <LangToggle />
        {user ? (
          <Link to="/profile" className="text-sm font-semibold text-ink hover:underline">
            {user.displayName?.split(' ')[0] ?? 'You'}
          </Link>
        ) : (
          <Link
            to="/signin"
            className="inline-flex min-h-[44px] items-center justify-center rounded-md bg-soi-600 px-4 py-2 text-sm font-semibold text-white shadow-s1 hover:bg-soi-700"
          >
            {t('nav.signin')}
          </Link>
        )}
      </nav>
    </header>
  );
}
